<script setup>
import { computed } from 'vue';
import QuotesHeader from '../QuotesHeader/QuotesHeader.vue';
import PaginationFooter from 'dashboard/components-next/pagination/PaginationFooter.vue';

const props = defineProps({
  searchValue: { type: String, default: '' },
  headerTitle: { type: String, required: true },
  currentPage: { type: Number, default: 1 },
  totalItems: { type: Number, default: 0 },
  itemsPerPage: { type: Number, default: 10 },
  activeSort: { type: String, default: 'created_at_desc' },
  showSearch: { type: Boolean, default: true },
});

const emit = defineEmits(['search', 'add', 'pageChange', 'update:sort']);

const hasPagination = computed(() => props.totalItems > props.itemsPerPage);
const totalPages = computed(() => Math.ceil(props.totalItems / props.itemsPerPage));
</script>

<template>
  <div class="flex flex-col min-h-full">
    <QuotesHeader
      :search-value="searchValue"
      :header-title="headerTitle"
      :active-sort="activeSort"
      :show-search="showSearch"
      @search="$emit('search', $event)"
      @add="$emit('add')"
      @update:sort="$emit('update:sort', $event)"
    />
    
    <main class="flex-1 overflow-y-auto">
      <div class="w-full mx-auto max-w-[60rem]">
        <slot name="empty" />
        <slot />
      </div>
    </main>
    
    <footer
      v-if="hasPagination"
      class="flex items-center justify-end px-6 py-4 border-t border-n-slate-5"
    >
      <PaginationFooter
        :current-page="currentPage"
        :total-pages="totalPages"
        @update:current-page="$emit('pageChange', $event)"
      />
    </footer>
  </div>
</template>
